exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".element-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;color:#c2c2c2;font-size:13px;padding:5px 10px;padding-left:20px;margin:3px;display:flex;flex-flow:row;align-items:center}.element-title i{margin-right:5px;margin-top:1px}.toolbox-element .element-title:hover{background:hsla(0,0%,100%,.05)}.toolbox-element{padding-left:0;line-height:20px}.toolbox-element .pop-content{position:absolute;top:70px;left:-340px;width:320px;padding:10px;background:#eee;z-index:1}.toolbox-element .pop-content img{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36e5d3d2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/Toolbox/Toolbox.vue
// module id = 62
// module chunks = 0 1